module.exports = __webpack_public_path__ + "img/01.c68cd962.png";